import { CurrentSessionSchema, type CurrentSession, type Permission } from '@nlc/contracts';
import { queryOptions } from '@tanstack/react-query';

import { apiRequest } from '../api/client.js';

export const sessionQuery = queryOptions({
  queryKey: ['session'],
  queryFn: () => apiRequest('/auth/me', CurrentSessionSchema),
  retry: false,
  staleTime: 60_000,
});

export function hasPermission(session: CurrentSession, permission: Permission): boolean {
  return session.permissions.includes(permission);
}
